import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledWrapper = styled.div`
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  width: 100%;
  justify-content: flex-start;

  p {
    text-align: center;
  }

  ${themeMedia.desktop`
    justify-content: flex-start;
  `}
`
export const StyledTextWraper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  width: 100%;
`
export const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  width: 100%;
`

export const StyledIcon = styled.img`
  width: 100px;
`
